// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11UU6","label":"styles_label__1fTZx"};